import { Currency, CurrencyList, CurrencyMappingList } from 'api/account';
import { CustomOption } from 'components/atoms/select';
import { PLACEHOLDER } from 'constant';

export type SelectableCurrencyOption = CustomOption<Currency>;

export const currencyOrderPreference = [
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'AUD',
  'JPY',
  'INR',
  'NZD',
  'CHF',
  'SGD',
  'HKD',
  'CNY',
  'MXN',
];

export const getCurrencyLabel = (
  { currencyCode, currencyName, currencySymbol }: Currency,
  showSymbol = true,
) =>
  `${currencyCode} ${PLACEHOLDER} ${currencyName} ${
    showSymbol ? `(${currencySymbol})` : ''
  }`;

export const asCurrencyOption = (
  currency: Currency,
): SelectableCurrencyOption => ({
  label: getCurrencyLabel(currency),
  value: currency.currencyCode,
  extra: currency,
});

export const getCurrencyListFromCurrencyMappingList = (
  currencies: CurrencyMappingList,
): CurrencyList => currencies.map(({ currency }) => currency);

export const selectableCurrencyOptions = (
  currencies: CurrencyList,
): SelectableCurrencyOption[] => currencies.map(asCurrencyOption);
